<template>
  <div class="button-wrapper">
    <modal
      id="global-search"
      class="global-search-dialog"
      title="Global Search"
      :is-open="isOpen"
      :size="'80%'"
      :show-header="true"
    >
      <global-search :is-open="isOpen" />
    </modal>
  </div>
</template>
<script>
import Modal from '../modal/Modal'
import ModalOpener from '../modal/Opener'
import GlobalSearch from './GlobalSearch'
import { mapActions } from 'vuex'

/**
 * @class GlobalSearchWrapper
 *
 * @description This component is the wrapper for GlobalSearch
 */
export default {
  name: 'global-search-wrapper',
  components: {
    Modal,
    ModalOpener,
    GlobalSearch,
  },
  methods: {
    ...mapActions(['showModal', 'hideModal']),
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.getters.isModalOpen('global-search') || false
      },
    },
  },
}
</script>

<style lang="scss">
.button-wrapper {
  width: 100%;
}
.global-search-dialog {
  .modal-dialog {
    width: 100% !important;
    min-width: 100% !important;
    height: 100% !important;
    padding: 0px !important;
    margin: 0px !important;
  }
  .modal-content {
    height: 100% !important;
    overflow-y: scroll;
  }
}
.global-search-content {
  padding: 20px !important;
  border-top: 1px solid #cfcfcf !important;
  background-color: #fffffe !important;
}
</style>
